import            '../../../css/Footer.css';
import React from 'react';

const Footer = () => {
  return <footer>Benny Solomon &copy; 2023</footer>;
};

export default Footer;
